export const incomingCallNotificationName = 'incoming-call';
export const newMessageNotificationName = 'new-message';
